import { Box, Dialog } from '@material-ui/core';
import React from 'react';

import { lightTheme } from '../lib/theme';
import { ModalButton } from './modalButton';

const { button } = lightTheme.components;

export const Modal = ({
  open,
  onClose,
  onConfirm,
  cancelButtonLabel = 'Отменить',
  confirmButtonLabel,
  confirmButtonStyle,
  onOption,
  optionButtonLabel,
  optionButtonStyle,
  children,
}: {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  cancelButtonLabel?: string;
  confirmButtonLabel: string;
  confirmButtonStyle?: React.CSSProperties;
  onOption?: () => void;
  optionButtonLabel?: string;
  optionButtonStyle?: React.CSSProperties;
  children: React.ReactNode;
}) => {
  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth="sm" disableRestoreFocus>
      <Box
        className="design-v3-font"
        width="100%"
        padding="50px"
        display="flex"
        flexDirection="column"
        minWidth={340}
      >
        <Box fontSize={24} fontWeight={600} marginBottom="40px">
          {children}
        </Box>

        {optionButtonLabel && onOption ? (
          <>
            <Box
              display="flex"
              flexDirection="row"
              // // flexWrap="wrap"
              // width="100%"
              gridColumnGap="8px"
              gridRowGap="8px"
            >
              <Box
              // flexGrow={0}
              >
                <ModalButton
                  label={confirmButtonLabel}
                  onClick={onConfirm}
                  style={{
                    background: button.primary.accent.bg,
                    color: button.primary.accent.label,
                    border: null,
                    // width: '100%',
                    ...confirmButtonStyle,
                  }}
                />
              </Box>
              <Box
              // flexGrow={1}
              >
                <ModalButton
                  label={optionButtonLabel}
                  onClick={onOption}
                  style={{
                    background: button.primary.accent.bg,
                    color: button.primary.accent.label,
                    border: null,
                    // width: '100%',
                    ...optionButtonStyle,
                  }}
                />
              </Box>
            </Box>
            <Box mt="8px">
              <ModalButton label={cancelButtonLabel} onClick={onClose} />
            </Box>
          </>
        ) : (
          <Box
            display="flex"
            flexDirection="row"
            flexWrap="wrap"
            // width="100%"
            gridColumnGap="24px"
            gridRowGap="24px"
          >
            <Box
            // flexGrow={1}
            >
              <ModalButton
                label={cancelButtonLabel}
                onClick={onClose}
                // style={{ width: '100%' }}
              />
            </Box>
            <Box
            // flexGrow={1}
            // textAlign={{ sm: 'right' }}
            >
              <ModalButton
                label={confirmButtonLabel}
                onClick={onConfirm}
                style={{
                  background: button.primary.accent.bg,
                  color: button.primary.accent.label,
                  border: null,
                  // width: '100%',
                  ...confirmButtonStyle,
                }}
              />
            </Box>
          </Box>
        )}
      </Box>
    </Dialog>
  );
};
